import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { ButtonBack } from '../../common/Button/ButtonBack';
import Links, { LinkItem } from '../../common/Widgets/Links';
import { SiteContext } from '../../../context/SiteContext';

const SiteMapPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);

  const chevronRightComponent = <FontAwesomeIcon icon={faChevronRight} />;
  const linkItems: LinkItem[] = [
    {
      to: PageAbsolutePath.Insurance.HelpPage,
      text: 'Contact Us'
    },
    {
      to: PageAbsolutePath.Insurance.MotorInsuranceClaim,
      text: 'Make a motor insurance claim'
    },
    {
      to: PageAbsolutePath.Insurance.EligibilityAncillaryPage,
      text: 'Eligibility for insurance quote'
    },
    {
      to: PageAbsolutePath.Insurance.FairUseNoticePage,
      text: 'Fair use notice'
    },
    {
      to: PageAbsolutePath.Insurance.TermsUseAncillaryPage,
      text: 'Terms of use'
    },
    {
      to: PageAbsolutePath.Insurance.BusinessTermsAncillaryPage,
      text: 'Terms of business'
    },
    {
      to: PageAbsolutePath.Insurance.TermsAndConditions,
      text: 'Terms and conditions'
    },
    {
      to: PageAbsolutePath.Insurance.CoverDetailsPage,
      text: 'Cover Details'
    },
    {
      to: PageAbsolutePath.Insurance.ElectricVehiclePage,
      text: 'Electric Vehicles'
    },
    {
      to: PageAbsolutePath.Insurance.ExcessReturnPolicyTermsConditions,
      text: 'Excess return policy terms and conditions'
    },
    {
      to: PageAbsolutePath.Insurance.FaqsPage,
      text: 'FAQs'
    },
    {
      to: PageAbsolutePath.Insurance.RetrieveQuote,
      text: 'Retrieve your quote'
    },
    {
      to: PageAbsolutePath.Insurance.ProofOfNcd,
      text: 'Proof of NCD'
    },
    {
      to: PageAbsolutePath.Insurance.RegisterExcessReturn,
      text: 'Register for excess return'
    },
    {
      to: PageAbsolutePath.Insurance.ServiceExcess,
      text: 'Service excess'
    },
    {
      to: PageAbsolutePath.Insurance.CustomerSelfRegistration,
      text: 'Customer self registration'
    },
    {
      to: PageAbsolutePath.Insurance.DriveAway,
      text: 'Eligibility for Driveaway Insurance'
    }
  ];

  const additionalLinkItems: LinkItem[] = [
    {
      to: PageAbsolutePath.Insurance.AccidentAssistance,
      text: 'Accident Assistance'
    }
  ];

  return (
    <div className='flex-row site-map'>
      <h2>Site Map</h2>
      <div className='flex-row'>
        <Links
          id='site-map-links'
          items={linkItems.concat(
            site.brand.showAssistanceLink ? additionalLinkItems : []
          )}
          icon={chevronRightComponent}
        />
      </div>
      <div className='flex-row'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={() => navigate(PageAbsolutePath.Insurance.Landing)}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};

export default SiteMapPage;
